import { render, staticRenderFns } from "./ButtonWatch.vue?vue&type=template&id=55414a6e&"
import script from "./ButtonWatch.vue?vue&type=script&lang=js&"
export * from "./ButtonWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports